import React from 'react';
import HeroSection from './HeroSection';
import QuickLinks from './QuickLinks';
import TodaysPlan from '../TodaysPlan';
import StudentPerformance from '../StudentPerformance';
import SyllabusSection from './SyllabusSection';
import RightSidebar from './RightSidebar';

const MainDashboard = ({ onNavigate }) => {
  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        {/* Main column */}
        <div className="lg:col-span-3 space-y-6">
          <HeroSection onNavigate={onNavigate} />
          <QuickLinks onNavigate={onNavigate} />

          <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
            <TodaysPlan />
            <StudentPerformance />
          </div>

          <SyllabusSection />
        </div>

        {/* Right sidebar column */}
        <div className="lg:col-span-1">
          <RightSidebar onNavigate={onNavigate} />
        </div>
      </div>
    </div>
  );
};

export default MainDashboard;